import { Link } from "react-router-dom";
import { CheckCircle2, MessageSquareText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useProfile } from "@/hooks/useProfile";
import { useFeedbackCandidates } from "@/hooks/useFeedbackCandidates";

const ProfileFeedbackLink = () => {
  const { data: profile } = useProfile();
  const { data: candidates, isLoading } = useFeedbackCandidates(profile?.id);

  if (isLoading || !candidates?.length) return null;

  const pendingCount = candidates.filter((candidate) => !candidate.submitted_at).length;
  const summary = pendingCount
    ? `${pendingCount} ${pendingCount === 1 ? "review" : "reviews"} waiting`
    : "Recent reviews submitted";

  return (
    <Card className="p-4">
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary/15">
          {pendingCount ? (
            <MessageSquareText className="h-5 w-5 text-primary" />
          ) : (
            <CheckCircle2 className="h-5 w-5 text-success" />
          )}
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-medium text-card-foreground">Feedback</p>
          <p className="text-sm text-muted-foreground">{summary}</p>
        </div>
        <Button asChild variant="ghost" size="sm">
          <Link to="/feedback">View</Link>
        </Button>
      </div>
    </Card>
  );
};

export default ProfileFeedbackLink;